import log, { LogLevelDesc } from 'loglevel'
import { z } from 'zod'

import packageJson from '../package.json'

const envSchema = z.object({
  VITE_REOWN_PROJECT_ID: z.string(),
  VITE_UNISWAP_V2_FACTORY_ADDR: z.string(),
  VITE_UNISWAP_V2_ROUTER_ADDR: z.string(),
  VITE_WETH_ADDR: z.string(),
  VITE_DEFAULT_ERC20_TOKENS: z.preprocess(
    val => (typeof val === 'string' ? val.split(',') : val),
    z.array(z.string()),
  ),
  VITE_UNISWAP_INDEXER_API_URL: z.string(),
  VITE_GRAPHQL_API_URL: z.string(),
})

export const config = {
  BUILD_VERSION: packageJson.version,
  LOG_LEVEL: 'trace' as LogLevelDesc,
  VITE_APP_NAME: 'Swap | Bitswapp',
  MODE: import.meta.env.MODE,
  ...envSchema.parse(import.meta.env),
  LIQUIDITY_OWNERS_FEE: 0.3, // %
  DISCORD_LINK: '',
  X_LINK: 'https://x.com/BitSwappDEX',
  DOC_LINK: 'https://docs.bitswapp.net',
  FAUCET_LINK: 'https://gas.bridgeless.com/',
}

log.setLevel(config.LOG_LEVEL)
